import { render, staticRenderFns } from "./ArticlePage.vue?vue&type=template&id=56a077ca&"
import script from "./ArticlePage.vue?vue&type=script&lang=js&"
export * from "./ArticlePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports